/*
    CTC - Modeller Data 2.0.0.0
*/

const CTCModellerMortalityData = require("./ctcMortalityData");
const ctcProductData = require("./ctcProductData");

const ctcProductChargesJSON = ctcProductData.ctcProductChargesJSON;
const ctcTaxDetailsJSON = ctcProductData.ctcTaxDetailsJSON;
const ctcFundDataJSON = require("./ctcFundData");

function CTCModellerResults() {
    this.FundAtPRA = 0;
    this.Fund = [];
    this.Income = [];
    this.Contributions = [];
    this.AdviserIncome = [];
    this.ProbabilityOfSurvival = [];
    this.OtherIncome = [];
    this.FundRanOutAge = 0;
    this.GuaranteedIncome = 0.0;
    this.GrossTargetAmount = 0.0;
}
function CTCModellerGrowthResults() {
    this.growthLevel = -1;
    this.TFC = 0.0;
    this.Annuity = 0.0;
    this.FundExhausionAge = 0.0;
    this.TaxDue = 0.0;
    this.TotalEmployerContributions = 0.0;
    this.TotalEmployeeContributions = 0.0;
    this.TotalNetContributions = 0.0;
    this.TotalTaxRelief = 0.0;
}

function CTCProjectionData() {
    this.EffectiveDate;
    this.DOB;
    this.AgeAtStart = 0.0;
    this.AgeAtEnd = 0.0;
    this.AccumulationMonths = 0;
    this.TotalMonths = 0;
}

function CTCModellerProjection() {
    this.arrTargetMatrix = [];
    this.results = null;

    this.projectionData = new CTCProjectionData();

    /* JSON holders */
    this.ctcProductCharges = null;
    this.ctcFundData = null;

    /* Mortality */
    this.ctcMortality = new CTCModellerMortalityData();
    this.ctcMortalityRates = [];

    /* Tax Details */
    this.ctcTaxDetails = new Object();
    this.ctcTaxDetail = new Object();
    this.fcaRates = null;
    this.nationalInsurance = null;

    /* Misc variables */
    this.inflationPcnt = 2.0;
    this.AIR = 0.0;

    /* Generic Functions */
    this.formateValueInputs = function (request) {
        request.Age = parseInt(request.Age, 10);
        request.PRA = parseInt(request.PRA, 10);
        request.FundValue = parseFloat(request.FundValue);
        if (request.AMC !== null) { request.AMC = parseFloat(request.AMC); }
        if (request.Growth !== null) { request.Growth = parseFloat(request.Growth); }
        if (request.AnnualEarnings !== null) { request.AnnualEarnings = parseFloat(request.AnnualEarnings); }
        if (request.AnnualEarningsIncrease !== null) { request.AnnualEarningsIncrease = parseFloat(request.AnnualEarningsIncrease); }
        if (request.EmployeeCont !== null) { request.EmployeeCont = parseFloat(request.EmployeeCont); }
        if (request.EmployerCont !== null) { request.EmployerCont = parseFloat(request.EmployerCont); }
        if (request.AnnualIncomeRequired !== null) { request.AnnualIncomeRequired = parseFloat(request.AnnualIncomeRequired); }
        if (request.AnnualIncomeReqIncrease !== null) { request.AnnualIncomeReqIncrease = parseFloat(request.AnnualIncomeReqIncrease); }
        if (request.AnnuityGteeYears !== null) { request.AnnuityGteeYears = parseInt(request.AnnuityGteeYears, 10); }
        if (request.SpousePercentage !== null) { request.SpousePercentage = parseFloat(request.SpousePercentage); }
    }
    this.formatDateObject = function (sDate) {
        var iSlash1, iSlash2, iSpace, iNewDay, iNewMonth, iNewYear, iStartOffSet = 0;
        var sDivider = '';
        var dDate;

        if (sDate instanceof Date) {
            dDate = sDate;
            return dDate;
        } else {
            dDate = new Date();
            dDate.setDate(1);
        }

        if (sDate.indexOf('/', 0) >= 0) {
            sDivider = '/';
        } else if (sDate.indexOf('-', 0) >= 0) {
            sDivider = '-';
        }

        if (isNaN(sDate[0])) {
            iStartOffSet = 1;
        }
        iSlash1 = sDate.indexOf(sDivider, 0);
        if (iSlash1 < 0) { iSlash1 = 0; }
        iSlash2 = sDate.indexOf(sDivider, iSlash1 + 1);
        if (iSlash2 < 0) { iSlash2 = 0; }
        iSpace = sDate.indexOf(' ', iSlash2 + 1);
        if (iSpace < 0) { iSpace = sDate.indexOf('T', iSlash2 + 1); }
        if (iSpace < 0) { iSpace = sDate.length; }

        iNewDay = parseInt(sDate.substring(iStartOffSet, iSlash1), 10);
        iNewMonth = parseInt(sDate.substring(iSlash1 + 1 + iStartOffSet, iSlash2), 10);
        iNewYear = parseInt(sDate.substring(iSlash2 + 1 + iStartOffSet, iSpace), 10);
        if (iNewYear < 20) {
            iNewYear = parseInt('20' + iNewYear, 10);
        } else if (iNewYear < 100) {
            iNewYear = parseInt('19' + iNewYear, 10);
        }

        // Must set Year then Month then Day
        // To avoid auto-resolve of dates
        dDate.setFullYear(iNewYear);
        dDate.setMonth(iNewMonth - 1);
        dDate.setDate(iNewDay);
        dDate.setHours(1);
        dDate.setMinutes(1);
        dDate.setSeconds(1);
        dDate.setMilliseconds(1);

        return dDate;
    };

    this.ageAtDate = function (startDate, endDate) {
        var dStartDate, dEndDate;
        var startYear, startMonth, startDay = 0;
        var endYear, endMonth, endDay = 0;
        var yearOffset, monthOffset = 0;

        dStartDate = this.formatDateObject(startDate);
        dEndDate = this.formatDateObject(endDate);

        startYear = dStartDate.getFullYear();
        endYear = dEndDate.getFullYear();
        startMonth = dStartDate.getMonth() + 1;
        endMonth = dEndDate.getMonth() + 1;
        startDay = dStartDate.getDate();
        endDay = dEndDate.getDate();

        yearOffset = endYear - startYear;

        if (endMonth < startMonth) {
            // Take off a year
            yearOffset -= 1;
            if (startDay === endDay) {
                // Add back in month roll up
                monthOffset = (12 - (startMonth - endMonth)) / 12;
            } else if (startDay < endDay) {
                // Add back in month roll up
                monthOffset = 1 - ((startMonth - endMonth) / 12);
            } else {
                monthOffset = (12 - (startMonth - endMonth)) / 12;
                monthOffset -= (1 / 12);
                // IncludeDays XXX
            }
        } else if (endMonth === startMonth) {
            if (endDay < startDay) {
                // IncludeDays XXX
                monthOffset -= (1 / 12);
            } else if (endDay > startDay) {
                // IncludeDays XXX
            }
        } else {
            monthOffset = (endMonth - startMonth) / 12;
            if (endDay === startDay) {
                // Do nothing
            } else if (endDay < startDay) {
                monthOffset -= (1 / 12);
                // IncludeDays XXX
            } else {
                // IncludeDays XXX
            }
        }

        return (yearOffset + monthOffset);
    };

    this.roundToInteger = function (nNum) {
        var Tole = 0.00001;

        nNum = Math.floor(nNum + Tole);
        return nNum;
    };

    this.formatDPS = function (nValue, iDPS) {
        var iOffSet = 1;
        var i;

        nValue = parseFloat(nValue);
        if (isNaN(nValue)) { nValue = 0; }

        for (i = 0; i < iDPS; i++) {
            iOffSet = iOffSet * 10;
        }
        nValue = nValue * iOffSet;
        nValue = Math.round(nValue, 2);
        nValue = parseFloat(nValue / iOffSet);
        nValue = nValue.toFixed(iDPS);
        return parseFloat(nValue);
    };

    this.round3SigFig = function (x) {
        var adjust_factor = 0.0;
        var digits = 0.0;

        x = x + 0.00000001;
        if (x < 1000) {
            return Math.round(x);
        }
        else {
            x = Math.round(x);
            digits = Math.floor(Math.log(x) / Math.log(10)) + 1;
            adjust_factor = Math.pow(10, digits - 3);
            return Math.floor(x / adjust_factor) * adjust_factor;
        }
    };

    this.sortArray = function (arrToSort, keyToSortOn, Ascending) {
        arrToSort.sort(function (itemA, itemB) {
            if (Ascending) {
                return itemA[keyToSortOn] - itemB[keyToSortOn];
            } else {
                return itemB[keyToSortOn] - itemA[keyToSortOn];
            }
        });
    };

    /* JSON Functions */
    this.setupJSONList = function (data) {
        var i = 0;
        var j = 0;
        if (!data) { return; }

        if (data["fundList"]) {
            this.ctcFundData = data["fundList"];
            // Sort lookup arrays
            for (i = 0; i < this.ctcFundData.length; i++) {
                for (j = 0; j < this.ctcFundData[i].Expense.length; j++) {
                    switch (this.ctcFundData[i].Expense[j].type) {
                        case 'IGTE':
                            // Sort GIR
                            this.sortArray(this.ctcFundData[i].Expense[j].GIR, 'age', true);
                        case 'CGTE':
                            // Sort Charges
                            this.sortArray(this.ctcFundData[i].Expense[j].charges, 'term', true);
                            break;
                    }
                }
            }

        } else if (data["productCharge"]) {
            this.ctcProductCharges = data["productCharge"];
            // Sort lookup arrays
            this.sortArray(this.ctcProductCharges.tiers, 'maxThreshold', true);
        }
    };

    this.setupTaxDetails = function (region, effectiveDate) {
        var dEffective;
        var dTest;
        var i = 0;

        dEffective = this.formatDateObject(effectiveDate);

        // Annuity
        this.ctcTaxDetails.fcaRates.forEach(rate => {
            dTest = new Date(rate.effectiveDate);
            dTest.setHours(1, 1, 1).toString();
            if (dEffective >= dTest) {
                this.fcaRates = rate;
            }
        });

        if (this.fcaRates != null) {
            this.inflationPcnt = parseFloat(this.fcaRates.inflationRate);
            this.AIR = parseFloat(this.fcaRates.AIR);
        }

        // Tax Details
        for (i = 0; i < this.ctcTaxDetails.taxDetails.length; i++) {
            switch (region) {
                case 'Scotland':
                case 'scotland':
                    if (this.ctcTaxDetails.taxDetails[i].region == 'Scotland') {
                        this.ctcTaxDetail = this.ctcTaxDetails.taxDetails[i];
                        break;
                    }

                default:
                    if (this.ctcTaxDetails.taxDetails[i].region == 'UK') {
                        this.ctcTaxDetail = this.ctcTaxDetails.taxDetails[i];
                        break;
                    }
            }
        }

        // National Insurance
        this.nationalInsurance = this.ctcTaxDetails.nationalInsurance;
    };

    this.initialiseProjectionData = function (PRA, region, location, gender, dob, age, IncomeTerm, Incomes) {
        var Today = new Date();

        if (region === null) { region = 'England'; }
        if (gender === null) { gender = 'Male'; }

        this.projectionData.EffectiveDate = Today.getDate() + '/' + (Today.getMonth() + 1).toString() + '/' + Today.getFullYear();
        this.initialise_ModellerData(region, gender, this.projectionData.EffectiveDate);
        this.initialiseResults();

        if (age === null) {
            // Assume that dob will always be non-NULL when age is NULL
            this.projectionData.AgeAtStart = this.ageAtDate(dob, this.projectionData.EffectiveDate);
        } else {
            age = parseInt(age, 10);
            dob = Today.getDate() + '/' + (Today.getMonth() + 1).toString() + '/' + (Today.getFullYear() - age).toString();
            this.projectionData.AgeAtStart = age;
        }
        this.projectionData.DOB = this.formatDateObject(dob);

        this.projectionData.AccumulationMonths = Math.floor(((PRA - this.projectionData.AgeAtStart) * 12) + 0.00001);
        if (IncomeTerm) {
            this.projectionData.TotalMonths = this.calculateIncomeEndMonth(Incomes, this.projectionData.AgeAtStart);
            if (this.projectionData.TotalMonths === 0) {
                this.projectionData.TotalMonths = this.projectionData.AccumulationMonths;
            }
        } else {
            this.projectionData.TotalMonths = Math.floor(((120 - this.projectionData.AgeAtStart) * 12) + 0.00001);
        }
        this.projectionData.AgeAtEnd = this.projectionData.AgeAtStart + (this.projectionData.TotalMonths / 12);
    }

    this.initialise_ModellerData = function (region, gender, effectiveDate) {
        this.setupJSONList(ctcProductChargesJSON);
        this.setupJSONList(ctcFundDataJSON);

        // Tax Details
        this.ctcTaxDetails = ctcTaxDetailsJSON;
        this.setupTaxDetails(region, effectiveDate);

        switch (gender) {
            case 'Male':
            case 'male':
            case 'M':
                gender = 'M';
                break;
            case 'Female':
            case 'female':
            case 'F':
                gender = 'F';
                break;
        }

        // Mortality Rates
        switch (region) {
            case 'England':
            case 'england':
                switch (gender) {
                    case 'M':
                        this.ctcMortalityRates = this.ctcMortality.dataEnglandMale;
                        break;
                    case 'F':
                        this.ctcMortalityRates = this.ctcMortality.dataEnglandFemale;
                        break;
                }
                break;
            case 'NorthernIreland':
            case 'northernireland':
            case 'Northern Ireland':
            case 'northern ireland':
            case 'Ireland':
            case 'ireland':
                switch (gender) {
                    case 'M':
                        this.ctcMortalityRates = this.ctcMortality.dataIrelandMale;
                        break;
                    case 'F':
                        this.ctcMortalityRates = this.ctcMortality.dataIrelandFemale;
                        break;
                }
                break;
            case 'Scotland':
            case 'scotland':
                switch (gender) {
                    case 'M':
                        this.ctcMortalityRates = this.ctcMortality.dataScotlandMale;
                        break;
                    case 'F':
                        this.ctcMortalityRates = this.ctcMortality.dataScotlandFemale;
                        break;
                }
                break;
            case 'Wales':
            case 'wales':
                switch (gender) {
                    case 'M':
                        this.ctcMortalityRates = this.ctcMortality.dataWalesMale;
                        break;
                    case 'F':
                        this.ctcMortalityRates = this.ctcMortality.dataWalesFemale;
                        break;
                }
                break;
        }
    };

    /* Fund Functions */
    this.getFundData = function (fundName) {
        var i = 0;

        for (i = 0; i < this.ctcFundData.length; i++) {
            if (this.ctcFundData[i].Name === fundName) {
                return this.ctcFundData[i];
            }
        }
        return null;
    };
    this.getFundRefData = function (fundRef) {
        var i = 0;

        for (i = 0; i < this.ctcFundData.length; i++) {
            if (this.ctcFundData[i].ID === fundRef) {
                return this.ctcFundData[i];
            }
        }

        return null;
    };

    // fundRef = Ref of the fund
    // ageAtOutset = Client's age at the start of the quotation
    this.getFundGIR = function (fundRef, ageAtOutset) {
        var oFund = this.getFundRefData(fundRef);
        var i, j = 0;
        var nGIR = 0.0;
        var bFound = false;

        for (i = 0; i < oFund.Expense.length; i++) {
            switch (oFund.Expense[i].type) {
                case 'IGTE':
                    bFound = true;
                    for (j = 0; j < oFund.Expense[i].GIR.length; j++) {
                        if (ageAtOutset >= oFund.Expense[i].GIR[j].age) {
                            nGIR = parseFloat(oFund.Expense[i].GIR[j].value);
                        } else {
                            break;
                        }
                    }
                    break;
            }
            if (bFound) { break; }
        }
        return nGIR;
    };

    // fundRef = Ref of the fund
    // fundType = Guarantee Type
    // term = Guarantee Term
    this.getFundGteeCharge = function (fundRef, fundType, term) {
        var oFund = this.getFundRefData(fundRef);
        var i, j = 0;
        var nCharge = 0.0;

        for (i = 0; i < oFund.Expense.length; i++) {
            switch (oFund.Expense[i].type) {
                case 'CGTE':
                case 'IGTE':
                    if (fundType === oFund.Expense[i].type) {
                        nCharge = 0.0;
                        for (j = 0; j < oFund.Expense[i].charges.length; j++) {
                            if (term >= parseInt(oFund.Expense[i].charges[j].term * 12, 10)) {
                                nCharge = parseFloat(oFund.Expense[i].charges[j].value);
                            } else {
                                break;
                            }
                        }
                    }
                    break;
            }
        }
        return nCharge;
    };

    /* Product Functions */
    this.getProductChargeRate = function (fundValue) {
        var i = 0;

        fundValue = parseFloat(fundValue);

        for (i = 0; i < this.ctcProductCharges.tiers.length; i++) {
            if (parseFloat(this.ctcProductCharges.tiers[i].maxThreshold) > fundValue) {
                return parseFloat(this.ctcProductCharges.tiers[i].rate);
            }
        }
        return 0.0;
    };

    /* Mortality Functions */
    this.getMortalityRate = function (year_of_birth, age) {
        var iDOBPosition = this.ctcMortality.dobOffset;
        var iAgePosition = this.ctcMortality.ageOffset;
        var nRate = -1.0;
        var iAgeToUse = parseInt(age, 10);

        if (age < this.ctcMortality.ageOffset) {
            iAgeToUse = this.ctcMortality.ageOffset;
        }

        iDOBPosition = parseInt(year_of_birth, 10) - iDOBPosition;
        if (iDOBPosition >= this.ctcMortalityRates.length) {
            iDOBPosition = this.ctcMortalityRates.length - 1;
        }
        iAgePosition = parseInt(iAgeToUse, 10) - iAgePosition;

        nRate = parseFloat(this.ctcMortalityRates[iDOBPosition][iAgePosition]);
        return nRate;
    };
    this.getUnisexRate = function (yearOfBirth, age) {
        var yearIndex = 0;
        var ageIndex = 0;
        var ageLower = 0;
        var ageUpper = 0;
        var lower = 0.0;
        var upper = 0.0;

        if (yearOfBirth < this.ctcMortality.unisexDobOffset) { yearOfBirth = this.ctcMortality.unisexDobOffset; }
        yearIndex = yearOfBirth - this.ctcMortality.unisexDobOffset + 1;

        if (age < this.ctcMortality.unisexAgeOffset) { age = this.ctcMortality.unisexAgeOffset; }
        ageLower = parseInt(age, 10);
        if (ageLower != age) { ageUpper = ageLower + 1; }

        // Calculate Lower age bracket
        ageIndex = ageLower - this.ctcMortality.unisexAgeOffset;
        lower = parseFloat(this.ctcMortality.dataUnisex[yearIndex][ageIndex]);

        if (ageLower != age) {
            // Calculate Upper age bracket and interpolate
            ageIndex = ageUpper - this.ctcMortality.unisexAgeOffset;
            upper = parseFloat(this.ctcMortality.dataUnisex[yearIndex][ageIndex]);

            lower = lower - (lower - upper) * (age - ageLower)
        }

        return lower;
    };

    /* TargetArea Functions */
    this.TargetArea = function (cont, fund) {
        this.cont = cont;
        this.fund = fund;
    };

    this.addTargetArea = function (cont, fund) {
        this.arrTargetMatrix[this.arrTargetMatrix.length] = new this.TargetArea(cont, fund);
    };

    this.checkForFundExhaustion = function (oCTC) {
        var i = 0;

        if (oCTC.AdhocCharges.length > 0) {
            for (i = 0; i < oCTC.AdhocCharges.length; i++) {
                if ((oCTC.AdhocCharges[i].Age >= oCTC.PRA) && (oCTC.AdhocCharges[i].Type === "P") && (oCTC.AdhocCharges[i].Amount === 100.0)) {
                    return true;
                }
            }
        }

        if (oCTC.PCLSAge) {
            if ((oCTC.PCLSAge >= oCTC.PRA) && (oCTC.PCLSPercentage === 100.0)) {
                return true;
            }
        }
        return false;
    };

    this.getTargetContributionOrGrowth = function (oCTC, nTotalMonths, realBoolean, nOffset) {
        var FirstGuessCont = 0.0;
        var SecondGuessCont = 0.0;
        var NewCont = 0.0;
        var nEsc = 0.0;
        var nTargetFund = 0.0;
        var nFund = 0.0;
        var nTotalGteeFund = 0.0;
        var SnValue = 0.0;
        var nFund1 = 0.0;
        var nFund2 = 0.0;
        var i = 0;
        var j = 0;
        var nInflation = this.inflationPcnt;
        var nFreq = 0;
        var nCnt = 0;
        var nMonthsOffset = 0;
        var nSeed1 = 0;
        var nSeed2 = 0;
        var nTole = 0.0;
        var bValidResult = true;
        var nNonZeroTargetFund = 0.0;
        var nNonZeroTotalMonths = 0;

        NewCont = 0.0;
        nMonthsOffset = 0;

        if (oCTC.ProjectionMethod == 2) {
            nTargetFund = oCTC.TargetFund;

            if (realBoolean) {
                nTargetFund = nTargetFund * Math.pow(1.0 + nInflation / 100.0, Math.floor(nTotalMonths / 12.0));
            }
        } else if (oCTC.TargetFund > 0.0) {
            nTotalMonths = this.calculateIncomeEndMonth(oCTC.Income, this.projectionData.AgeAtStart);
            nTargetFund = oCTC.TargetFund;
        } else {
            nTotalMonths = 0;
            nTargetFund = 0.0;
            for (i = 0; i < oCTC.Income.length; i++) {
                j = Math.floor(((oCTC.Income[i].IncomeStartAge + oCTC.Income[i].Term) - this.projectionData.AgeAtStart) * 12 + 0.00001);
                if (j > nTotalMonths) {
                    nTotalMonths = j;
                    j = oCTC.Income[i].Term - 1;
                    if (oCTC.Income[i].Frequency === "A") {
                        nMonthsOffset = 12;
                    } else {
                        nMonthsOffset = 1;
                    }
                    nTargetFund = oCTC.Income[i].Amount * Math.pow(1.0 + oCTC.Income[i].Escalation / 100, j);
                    if (nTargetFund > 0.0) {
                        nNonZeroTargetFund = nTargetFund;
                        nNonZeroTotalMonths = nTotalMonths - nMonthsOffset;
                    }
                    for (j = 0; j < oCTC.IncomeVariance.length; j++) {
                        if (oCTC.IncomeVariance[j].VarianceType === "A") {
                            nTargetFund += oCTC.IncomeVariance[j].Amount;
                        } else {
                            nTargetFund = nTargetFund * (1.0 + oCTC.IncomeVariance[j].Amount / 100.0);
                        }
                        if (nTargetFund > 0.0) {
                            nNonZeroTargetFund = nTargetFund;
                            nNonZeroTotalMonths = nTotalMonths - nMonthsOffset;
                        }
                    }
                }
            }

            nTotalMonths -= nMonthsOffset;
        }

        if ((nTargetFund <= 0.0) && (nNonZeroTargetFund != 0.0)) {
            nTargetFund = nNonZeroTargetFund;
            nTotalMonths = nNonZeroTotalMonths;
        }

        if (((oCTC.ProjectionMethod == 5) || (oCTC.ProjectionMethod == 6) || (oCTC.ProjectionMethod == 7)) && (this.checkForFundExhaustion(oCTC))) {
            this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths + nMonthsOffset, 0, 0, true, false, nOffset, true);
            return 0;
        }

        nFund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, 0, true, true, nOffset, true);
        if ((nTargetFund > nFund) || (oCTC.ProjectionMethod == 5)) {
            if ((oCTC.ProjectionMethod == 6) || (oCTC.ProjectionMethod == 5)) {
                nFreq = 0;
                nEsc = 0.0;
            } else {
                if (oCTC.RegularConts.length > 0) {
                    if (oCTC.RegularConts[0].Frequency === "A") {
                        nFreq = 1;
                    } else {
                        nFreq = 12;
                    }
                    nEsc = parseFloat(oCTC.RegularConts[0].Escalation);
                } else {
                    nFreq = 12;
                    nEsc = 0.0;
                }
            }

            if (oCTC.ProjectionMethod == 5) {
                oCTC.Growth = 0.0;
                nFund1 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, nSeed1, 0, true, true, nOffset, true);
                if (nFund1 > nTargetFund) {
                    nSeed1 = -70.00;
                    nSeed2 = 0.00;
                } else {
                    nSeed1 = 2.00;
                    nSeed2 = 8.00;
                    oCTC.Growth = nSeed1;
                    nFund1 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, nSeed1, 0, true, true, nOffset, true);
                    oCTC.Growth = nSeed2;
                    nFund2 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, nSeed2, 0, true, true, nOffset, true);
                    if (nTargetFund > nFund2) {
                        do {
                            nSeed1 = nSeed2;
                            nSeed2 = 2.0 * nSeed1;
                            oCTC.Growth = nSeed2;
                            nFund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, nSeed2, 0, true, true, nOffset, true);
                        } while (nFund < nTargetFund);
                    } else if (nTargetFund < nFund1) {
                        nCnt = 1;
                        do {
                            nSeed2 = nSeed1;
                            nSeed1 = nSeed1 / 2;
                            oCTC.Growth = nSeed1;
                            nFund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, nSeed2, 0, true, true, nOffset, true);
                            nCnt += 1;
                        } while ((nFund > nTargetFund) && (nCnt < 100));
                    }
                }
                FirstGuessCont = nSeed1;
                SecondGuessCont = nSeed2;
            } else if ((oCTC.ProjectionMethod == 6) || (oCTC.ProjectionMethod == 7)) {
                if (oCTC.ProjectionMethod == 6) {
                    nSeed1 = 100000.00;
                    nSeed2 = 200000.00;
                } else {
                    nSeed1 = 100.00 * nFreq;
                    nSeed2 = 200.00 * nFreq;
                }
                nFund1 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, nSeed1, 0, true, true, nOffset, true);
                nFund2 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, nSeed2, 0, true, true, nOffset, true);
                if (nTargetFund < nFund1) {
                    FirstGuessCont = 0.0;
                    SecondGuessCont = nSeed1;
                } else if (nTargetFund > nFund2) {
                    FirstGuessCont = nSeed2;
                    SecondGuessCont = nSeed1 + ((nSeed2 - nSeed1) * (nTargetFund - nFund1) / (nFund2 - nFund1));
                } else {
                    FirstGuessCont = nSeed1;
                    SecondGuessCont = nSeed2;
                }
            } else {
                SnValue = this.Sn(oCTC.Growth / 100.0, oCTC.FMC / 100.0, nEsc / 100.0, nTotalMonths / 12, nFreq);
                FirstGuessCont = (nTargetFund - this.results.FundAtPRA) / SnValue;
                SecondGuessCont = FirstGuessCont * 1.5;
            }
            if (oCTC.ProjectionMethod == 5) {
                oCTC.Growth = FirstGuessCont;
                nFund1 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, 0, true, true, nOffset, true);
                oCTC.Growth = SecondGuessCont;
                nFund2 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, 0, true, true, nOffset, true);
            } else {
                nFund1 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, FirstGuessCont, 0, true, true, nOffset, true);
                nFund2 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, SecondGuessCont, 0, true, true, nOffset, true);
            }
            this.addTargetArea(FirstGuessCont, nFund1);
            this.addTargetArea(SecondGuessCont, nFund2);
            this.addTargetArea(0, 0);

            nCnt = 1;
            nTole = 0.001;
            do {
                if (oCTC.ProjectionMethod == 5) {
                    this.arrTargetMatrix[2].cont = this.arrTargetMatrix[0].cont + (this.arrTargetMatrix[1].cont - this.arrTargetMatrix[0].cont) * Math.log(nTargetFund - this.arrTargetMatrix[0].fund) / Math.log(this.arrTargetMatrix[1].fund - this.arrTargetMatrix[0].fund);
                    oCTC.Growth = this.arrTargetMatrix[2].cont;
                    this.arrTargetMatrix[2].fund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, 0, true, true, nOffset, true);
                } else {
                    if ((this.arrTargetMatrix[1].fund - this.arrTargetMatrix[0].fund) !== 0.0) {
                        this.arrTargetMatrix[2].cont = this.arrTargetMatrix[0].cont + ((this.arrTargetMatrix[1].cont - this.arrTargetMatrix[0].cont) * (nTargetFund - this.arrTargetMatrix[0].fund) / (this.arrTargetMatrix[1].fund - this.arrTargetMatrix[0].fund));
                    }
                    this.arrTargetMatrix[2].fund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, this.arrTargetMatrix[2].cont, 0, true, true, nOffset, true);
                }

                if ((this.arrTargetMatrix[2].fund >= (nTargetFund - 1)) && (this.arrTargetMatrix[2].fund <= (nTargetFund + 1))) {
                    break;
                } else if (this.arrTargetMatrix[2].fund > 0.0) {
                    if ((nTargetFund / this.arrTargetMatrix[2].fund >= (1.0 - nTole)) && (nTargetFund / this.arrTargetMatrix[2].fund <= (1.0 + nTole))) {
                        break;
                    }
                }

                if (nTargetFund > this.arrTargetMatrix[1].fund) {
                    this.arrTargetMatrix[0].cont = this.arrTargetMatrix[1].cont;
                    this.arrTargetMatrix[0].fund = this.arrTargetMatrix[1].fund;
                    this.arrTargetMatrix[1].cont = this.arrTargetMatrix[2].cont;
                    this.arrTargetMatrix[1].fund = this.arrTargetMatrix[2].fund;
                } else if (nTargetFund < this.arrTargetMatrix[0].fund) {
                    this.arrTargetMatrix[1].cont = this.arrTargetMatrix[0].cont;
                    this.arrTargetMatrix[1].fund = this.arrTargetMatrix[0].fund;
                    this.arrTargetMatrix[0].cont = this.arrTargetMatrix[2].cont;
                    this.arrTargetMatrix[0].fund = this.arrTargetMatrix[2].fund;
                } else {
                    if (nTargetFund > this.arrTargetMatrix[2].fund) {
                        this.arrTargetMatrix[0].cont = this.arrTargetMatrix[2].cont;
                        this.arrTargetMatrix[0].fund = this.arrTargetMatrix[2].fund;
                    } else {
                        this.arrTargetMatrix[1].cont = this.arrTargetMatrix[2].cont;
                        this.arrTargetMatrix[1].fund = this.arrTargetMatrix[2].fund;
                    }
                }

                nCnt += 1;
                if (nCnt > 100) {
                    nTole = nTole + 0.001;
                }
            } while (nCnt < 1000);
            NewCont = this.arrTargetMatrix[2].cont;
        } else {
            NewCont = 0.0;
        }

        if (oCTC.ProjectionMethod == 6) {
            nTotalGteeFund = 0.0;
            for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                nTotalGteeFund += oCTC.CapitalGtees[i].Amount;
            }
            for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                nTotalGteeFund += oCTC.IncomeGtees[i].Amount;
            }
            if (NewCont < nTotalGteeFund) {
                NewCont = nTotalGteeFund;
            }
        }

        bValidResult = true;
        if ((oCTC.ProjectionMethod == 2) || (oCTC.ProjectionMethod == 7)) {
            bValidResult = true;
            for (i = 0; i < this.results.Contributions.length; i++) {
                if (this.results.Contributions[i] < 0.0) {
                    bValidResult = false;
                    break;
                }
            }
        }

        this.resetResultArray();
        if (oCTC.ProjectionMethod == 5) {
            oCTC.Growth = this.arrTargetMatrix[2].cont;
            this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths + nMonthsOffset, 0, 0, true, false, nOffset, true);
        } else if (bValidResult) {
            this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths + nMonthsOffset, NewCont, 0, true, false, nOffset, true);
        } else {
            NewCont = 0.0;
        }
        return NewCont;
    };

    this.getMaximumIncome = function (oCTC, nTotalMonths, nOffset) {
        var nCnt = 0;
        var nIncome = 0.0;
        var nFund = 0.0;
        var nFund1 = 0.0;
        var nFund2 = 0.0;
        var nTole = 0.0;
        var FirstGuessIncome = 0.0;
        var SecondGuessIncome = 0.0;
        var nSeed1 = 0.0;
        var nSeed2 = 0.0;
        var nTargetFund = 0.0;

        if (this.checkForFundExhaustion(oCTC)) {
            this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, 0, true, false, nOffset, true);
            return 0;
        }

        nTargetFund = oCTC.TargetFund;

        nFund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, 0, true, true, nOffset, true);
        if (nFund <= oCTC.TargetFund) {
            nIncome = 0.0;
        } else {
            nSeed1 = 1000.00;
            nSeed2 = 2000.00;

            nFund1 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, nSeed1, true, true, nOffset, true);
            nFund2 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, nSeed2, true, true, nOffset, true);
            if (nTargetFund < nFund1) {
                FirstGuessIncome = 0.0;
                SecondGuessIncome = nSeed1;
            } else if (nTargetFund > nFund2) {
                FirstGuessIncome = nSeed2;
                SecondGuessIncome = nSeed1 + ((nSeed2 - nSeed1) * (nTargetFund - nFund1) / (nFund2 - nFund1));
            } else {
                FirstGuessIncome = nSeed1;
                SecondGuessIncome = nSeed2;
            }

            nFund1 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, FirstGuessIncome, true, true, nOffset, true);
            nFund2 = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, SecondGuessIncome, true, true, nOffset, true);
            this.addTargetArea(FirstGuessIncome, nFund1);
            this.addTargetArea(SecondGuessIncome, nFund2);
            this.addTargetArea(0, 0);

            nCnt = 1;
            nTole = 0.001;
            do {
                if ((this.arrTargetMatrix[1].fund - this.arrTargetMatrix[0].fund) !== 0.0) {
                    this.arrTargetMatrix[2].cont = this.arrTargetMatrix[0].cont + ((this.arrTargetMatrix[1].cont - this.arrTargetMatrix[0].cont) * (nTargetFund - this.arrTargetMatrix[0].fund) / (this.arrTargetMatrix[1].fund - this.arrTargetMatrix[0].fund));
                }
                this.arrTargetMatrix[2].fund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, this.arrTargetMatrix[2].cont, true, true, nOffset, true);

                if ((this.arrTargetMatrix[2].fund >= (oCTC.TargetFund - 1)) && (this.arrTargetMatrix[2].fund <= (oCTC.TargetFund + 1))) {
                    break;
                } else if (this.arrTargetMatrix[2].fund > 0.0) {
                    if ((oCTC.TargetFund / this.arrTargetMatrix[2].fund >= (1.0 - nTole)) && (oCTC.TargetFund / this.arrTargetMatrix[2].fund <= (1.0 + nTole))) {
                        break;
                    }
                }

                if (oCTC.TargetFund > this.arrTargetMatrix[1].fund) {
                    this.arrTargetMatrix[0].cont = this.arrTargetMatrix[1].cont;
                    this.arrTargetMatrix[0].fund = this.arrTargetMatrix[1].fund;
                    this.arrTargetMatrix[1].cont = this.arrTargetMatrix[2].cont;
                    this.arrTargetMatrix[1].fund = this.arrTargetMatrix[2].fund;
                } else if (oCTC.TargetFund < this.arrTargetMatrix[0].fund) {
                    this.arrTargetMatrix[1].cont = this.arrTargetMatrix[0].cont;
                    this.arrTargetMatrix[1].fund = this.arrTargetMatrix[0].fund;
                    this.arrTargetMatrix[0].cont = this.arrTargetMatrix[2].cont;
                    this.arrTargetMatrix[0].fund = this.arrTargetMatrix[2].fund;
                } else {
                    if (oCTC.TargetFund > this.arrTargetMatrix[2].fund) {
                        this.arrTargetMatrix[0].cont = this.arrTargetMatrix[2].cont;
                        this.arrTargetMatrix[0].fund = this.arrTargetMatrix[2].fund;
                    } else {
                        this.arrTargetMatrix[1].cont = this.arrTargetMatrix[2].cont;
                        this.arrTargetMatrix[1].fund = this.arrTargetMatrix[2].fund;
                    }
                }

                nCnt += 1;
                if (nCnt > 100) {
                    nTole = nTole + 0.001;
                }
            } while (nCnt < 1000);
            nIncome = this.arrTargetMatrix[2].cont;
        }

        this.resetResultArray();
        nFund = this.projectBenefitsForward(oCTC, oCTC.FundValue, nTotalMonths, 0, nIncome, true, false, nOffset, true);
        return nIncome;
    };

    this.calculateNI = function (amount) {
        var NIRates;
        var totalNI = 0.0;
        var tierAmount = 0.0;
        var tierThreshold = 0.0;
        var ongoingTierAmount = 0.0;

        NIRates = this.nationalInsurance;
        // Deduct primary threshold
        for (var i = 0; i < NIRates.length; i++) {
            tierThreshold = NIRates[i].band;
            tierAmount = Math.max(Math.min(amount, tierThreshold) - ongoingTierAmount, 0.0);
            ongoingTierAmount += tierAmount;
            totalNI += tierAmount * NIRates[i].rate / 100.0;
        }

        return totalNI;
    };

    this.calculateNetCost = function (SalSac, AnnualGrossCont, GrossSalary) {
        var totalNetCost = 0.0;
        var totalDeductionsPre = 0.0;
        var totalDeductionsPost = 0.0;
        var totalSavings = 0.0;

        totalNetCost = AnnualGrossCont;
        totalDeductionsPre = this.calculateTaxOnIncome(GrossSalary, 0.0);
        if (SalSac) {
            totalDeductionsPost = this.calculateTaxOnIncome(GrossSalary - AnnualGrossCont, 0.0);
            totalDeductionsPre += this.calculateNI(GrossSalary);
            totalDeductionsPost += this.calculateNI(GrossSalary - AnnualGrossCont);
            totalSavings = totalDeductionsPre - totalDeductionsPost;
            totalNetCost -= totalSavings;
        } else {
            totalDeductionsPost = this.calculateTaxOnIncome(GrossSalary, AnnualGrossCont);
            totalSavings = totalDeductionsPre - totalDeductionsPost;

            var taxReliefRate = 0.0;
            var taxDetails;

            taxDetails = this.ctcTaxDetail;
            for (var i = 0; i < taxDetails.rates.length; i++) {
                if (taxDetails.rates[i].type == "basic") {
                    taxReliefRate = taxDetails.rates[i].rate / 100.0;
                    break;
                }
            }
            totalNetCost = AnnualGrossCont * (1.0 - taxReliefRate) - totalSavings;
        }
        return totalNetCost;
    };

    this.calculateTaxOnIncome = function (taxableAmount, Adj) {
        var personalAllowance = 0.0;
        var personalAllowanceLimit = 0.0;
        var previousThreshold = 0.0;
        var threshold = 0.0;
        var upperThreshold = 0.0;
        var accumulatedThreshold = 0.0;
        var remainingAmount;
        var tierAmount = 0.0;
        var taxDetails;
        var result = 0.0;
        var rate = 0.0;
        var tax = 0.0;
        var i = 0;
        var taxReliefRate = 0.0;

        taxDetails = this.ctcTaxDetail;
        if (Adj > 0.0) {
            for (i = 0; i < taxDetails.rates.length; i++) {
                if (taxDetails.rates[i].type == "basic") {
                    taxReliefRate = taxDetails.rates[i].rate / 100.0;
                    break;
                }
            }
        }
        personalAllowance = parseFloat(taxDetails.personalAllowance);
        personalAllowanceLimit = parseFloat(taxDetails.personalAllowanceLimit);
        if (taxableAmount < personalAllowanceLimit) {
            personalAllowance = Math.min(personalAllowance, taxableAmount);
        } else {
            personalAllowance = Math.max(personalAllowance - 0.5 * (taxableAmount - personalAllowanceLimit - Adj * (1.0 - taxReliefRate)), 0);
        }

        remainingAmount = taxableAmount - personalAllowance;
        accumulatedThreshold = personalAllowance;

        for (i = 0; i < taxDetails.rates.length; i++) {
            upperThreshold = parseFloat(taxDetails.rates[i].upperThreshold);
            rate = parseFloat(taxDetails.rates[i].rate) / 100.0;
            switch(taxDetails.rates[i].type){
                case "allowance":
                    // Do nothing as this was calculated in personalAllowance figure
                    break;
                case "standard":
                    threshold = upperThreshold - previousThreshold;
                    tierAmount = Math.min(threshold, remainingAmount);
                    tax = tierAmount * rate;

                    remainingAmount -= tierAmount;
                    result += tax;
                    break;
            }
            previousThreshold = upperThreshold;
        }

        return result;
    }

    this.calculateTaxOnExcessTFC = function (TFCPercentage, TotalFund) {
        var tfcForTax = 0.0;

        if (TFCPercentage > 25.0) {
            tfcForTax = (TFCPercentage - 25.0) / 100.0 * TotalFund;
            return this.calculateTaxOnIncome(tfcForTax, 0.0);
        } else {
            return 0.0;
        }
    };

    /* CALC Functions */
    this.initialiseResults = function () {
        this.results = new CTCModellerResults();
    };

    this.initialiseInputObjects = function (oCTC, nAge, nEndAge) {
        var i = 0;
        var newIndex = 0;
        var iWholeAge = parseInt(nAge, 10);
        var arrSalaries = [];

        for (i = 0; i < oCTC.GrowthVariance.length; i++) {
            if (oCTC.GrowthVariance[i].Age < nAge) {
                oCTC.GrowthVariance[i].Age = nAge;
            }
            oCTC.GrowthVariance[i].Age = this.formatDPS(oCTC.GrowthVariance[i].Age, 2);
        }
        for (i = 0; i < oCTC.PlannedConts.length; i++) {
            if (oCTC.PlannedConts[i].Age < nAge) {
                oCTC.PlannedConts[i].Age = nAge;
            }
            oCTC.PlannedConts[i].Age = this.formatDPS(oCTC.PlannedConts[i].Age, 2);
            oCTC.PlannedConts[i].Amount = oCTC.PlannedConts[i].Amount / (1.0 - oCTC.TaxRate / 100.0);
        }
        for (i = 0; i < oCTC.RegularConts.length; i++) {
            if (oCTC.RegularConts[i].Age < nAge) {
                oCTC.RegularConts[i].Age = nAge;
            }
            oCTC.RegularConts[i].Age = this.formatDPS(oCTC.RegularConts[i].Age, 2);
            oCTC.RegularConts[i].StopAge = 999;
            oCTC.RegularConts[i].Amount = oCTC.RegularConts[i].Amount / (1.0 - oCTC.TaxRate / 100.0);
        }
        for (i = 0; i < oCTC.RegularContsVariance.length; i++) {
            if (oCTC.RegularContsVariance[i].Age < nAge) {
                oCTC.RegularContsVariance[i].Age = nAge;
            }
            oCTC.RegularContsVariance[i].Age = this.formatDPS(oCTC.RegularContsVariance[i].Age, 2);
            if (oCTC.RegularContsVariance[i].VarianceType == "A") {
                oCTC.RegularContsVariance[i].Amount = oCTC.RegularContsVariance[i].Amount / (1.0 - oCTC.TaxRate / 100.0);
            }
        }
        for (i = 0; i < oCTC.AdhocCharges.length; i++) {
            if (oCTC.AdhocCharges[i].Age < nAge) {
                oCTC.AdhocCharges[i].Age = nAge;
            }
            oCTC.AdhocCharges[i].Age = this.formatDPS(oCTC.AdhocCharges[i].Age, 2);
        }
        for (i = 0; i < oCTC.Income.length; i++) {
            if (oCTC.Income[i].IncomeStartAge < nAge) {
                oCTC.Income[i].IncomeStartAge = nAge;
            }
            oCTC.Income[i].IncomeStartAge = this.formatDPS(oCTC.Income[i].IncomeStartAge, 2);
        }
        for (i = 0; i < oCTC.IncomeVariance.length; i++) {
            if (oCTC.IncomeVariance[i].Age < nAge) {
                oCTC.IncomeVariance[i].Age = nAge;
            }
            oCTC.IncomeVariance[i].Age = this.formatDPS(oCTC.IncomeVariance[i].Age, 2);
        }
        for (i = 0; i < oCTC.PlannedIncome.length; i++) {
            if (oCTC.PlannedIncome[i].Age < nAge) {
                oCTC.PlannedIncome[i].Age = nAge;
            }
            oCTC.PlannedIncome[i].Age = this.formatDPS(oCTC.PlannedIncome[i].Age, 2);
        }
        if (oCTC.PCLSAge < nAge) {
            oCTC.PCLSAge = this.formatDPS(nAge, 2);
        }
    };

    this.resetResultArray = function () {
        this.results.Fund = [];
        this.results.Income = [];
        this.results.Contributions = [];
        this.results.AdviserIncome = [];
        this.results.ProbabilityOfSurvival = [];
        this.results.OtherIncome = [];
    };

    this.projectBenefitsForward = function (oCTC, nStartingFund, nTotalMonths, nAdditionalContribution, nAdditionalIncome, bIncludeIncome, bIsTargetting, nOffset, bApplyDefaultProductCharge, growthModifier, growthBasis, growthResults) {
        var nCurrentMonth = 0;
        var nCurrentYear = 0;
        var nFreq = 0;
        var nAge = 0.0;
        var nAmount = 0.0;
        var nGrowth = 0.0;
        var nMonthlyGrowth = 0.0;
        var nProductCharge = 0.0;
        var nAdviserCharge = 0.0;
        var nAdviserChargeFromGteed = 0.0;
        var nProductChargeRate = 0.0;
        var nFund = 0.0;
        var nIncomeAmount = 0.0;
        var nIncomeTakenFromGteed = 0.0;
        var nIncomeVarianceEscalation = 0.0;
        var nIncomeVarianceAmount = 0.0;
        var nPaymentMonth = 0.0;
        var nTotalGteeFund = 0.0;
        var nCurrentFundAdviserCharge = 0.0;
        var nPCLS = 0.0;
        var i = 0;
        var j = 0;
        var bIncomeStarted = false;
        var bFundGreaterThanTargetAtIncomeStart = false;
        var bTestFundState = false;
        var nOACTakenFromGteed = 0.0;

        nAge = this.projectionData.AgeAtStart;
        nFund = nStartingFund;
        if ((nAdditionalContribution > 0.0) && (oCTC.ProjectionMethod === 6)) {
            nFund += nAdditionalContribution;
        }

        if (oCTC.IACPlannedAmount) {
            if (oCTC.IACPlannedType === "A") {
                nCurrentFundAdviserCharge = oCTC.IACPlannedAmount;
            } else {
                nCurrentFundAdviserCharge = nFund * oCTC.IACPlannedAmount / 100.0;
            }
        }

        if (!growthModifier) { growthModifier = 0.0; }
        growthModifier = parseFloat(growthModifier);


        nAmount = nFund;
        if (oCTC.CapitalGtees) {
            for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                nFund = Math.max(nFund - oCTC.CapitalGtees[i].Amount, 0.0);
                if (oCTC.CapitalGtees[i].Type === "Date") {
                    oCTC.CapitalGtees[i].Term = this.ageAtDate(this.projectionData.EffectiveDate, oCTC.CapitalGtees[i].Date);
                }

                oCTC.CapitalGtees[i].FundValue = oCTC.CapitalGtees[i].Amount;
                if ((nAmount != 0.0) && (nCurrentFundAdviserCharge != 0.0)) {
                    oCTC.CapitalGtees[i].FundValue = oCTC.CapitalGtees[i].FundValue * (1.0 - nCurrentFundAdviserCharge / nAmount);
                }
                oCTC.CapitalGtees[i].GMF = oCTC.CapitalGtees[i].FundValue;
                oCTC.CapitalGtees[i].GteeCharge = this.getFundGteeCharge(oCTC.CapitalGtees[i].Fund, "CGTE", oCTC.CapitalGtees[i].Term * 12);
            }
        }

        if (oCTC.IncomeGtees) {
            for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                nFund = Math.max(nFund - oCTC.IncomeGtees[i].Amount, 0.0);
                if (oCTC.IncomeGtees[i].Type === "Date") {
                    oCTC.IncomeGtees[i].Term = this.ageAtDate(this.projectionData.EffectiveDate, oCTC.IncomeGtees[i].Date);
                }
                oCTC.IncomeGtees[i].FundValue = oCTC.IncomeGtees[i].Amount;
                if ((nAmount != 0.0) && (nCurrentFundAdviserCharge != 0.0)) {
                    oCTC.IncomeGtees[i].FundValue = oCTC.IncomeGtees[i].FundValue * (1.0 - nCurrentFundAdviserCharge / nAmount);
                }
                oCTC.IncomeGtees[i].SIB = oCTC.IncomeGtees[i].FundValue;
                oCTC.IncomeGtees[i].GIRs = this.getFundGIR(oCTC.IncomeGtees[i].Fund, this.projectionData.AgeAtStart);
                oCTC.IncomeGtees[i].GteeCharge = this.getFundGteeCharge(oCTC.IncomeGtees[i].Fund, "IGTE", oCTC.IncomeGtees[i].Term * 12);
            }
        }

        if ((nAmount != 0.0) && (nCurrentFundAdviserCharge != 0.0)) {
            nFund = nFund * (1.0 - nCurrentFundAdviserCharge / nAmount);
        }

        this.results.GuaranteedIncome = 0.0;
        this.results.FundRanOutAge = -1;
        bFundGreaterThanTargetAtIncomeStart = false;

        // When the client's current age is the same as (or beyond) the Pension Retirement Age,
        // no accumulation occurs. Seed FundAtPRA with the current fund so downstream
        // calculations (TFC, Annuity, ProjectedFund_Monetary/Real, etc.) reflect the
        // actual pot value instead of defaulting to 0.
        if (this.projectionData.AgeAtStart >= oCTC.PRA) {
            this.results.FundAtPRA = nFund + nTotalGteeFund;
        }

        for (nCurrentMonth = 1; nCurrentMonth <= nTotalMonths; nCurrentMonth++) {
            nCurrentYear = Math.floor((nCurrentMonth + nOffset - 1) / 12.0);

            if ((((nCurrentMonth + nOffset - 1) % 12) === 0) || (nCurrentMonth == 1)) {
                if (isNaN(this.results.Fund[nCurrentYear])) {
                    this.results.Fund[nCurrentYear] = 0;
                }
                if (isNaN(this.results.Income[nCurrentYear])) {
                    this.results.Income[nCurrentYear] = 0;
                }
                if (isNaN(this.results.Contributions[nCurrentYear])) {
                    this.results.Contributions[nCurrentYear] = 0;
                }
                if (isNaN(this.results.AdviserIncome[nCurrentYear])) {
                    this.results.AdviserIncome[nCurrentYear] = 0;
                }
                if (isNaN(this.results.ProbabilityOfSurvival[nCurrentYear])) {
                    this.results.ProbabilityOfSurvival[nCurrentYear] = 0;
                }
                if (isNaN(this.results.OtherIncome[nCurrentYear])) {
                    this.results.OtherIncome[nCurrentYear] = 0;
                }
            }

            this.results.AdviserIncome[nCurrentYear] += nCurrentFundAdviserCharge;
            nCurrentFundAdviserCharge = 0.0;

            nGrowth = oCTC.Growth + growthModifier;
            if (oCTC.GrowthVariance) {
                for (i = 0; i < oCTC.GrowthVariance.length; i++) {
                    if (this.formatDPS(nAge, 2) >= oCTC.GrowthVariance[i].Age) {
                        nGrowth = nGrowth + oCTC.GrowthVariance[i].Variance;
                    }
                }
            }

            // Payments In
            if (oCTC.PlannedConts) {
                for (i = 0; i < oCTC.PlannedConts.length; i++) {
                    if (this.formatDPS(nAge, 2) == oCTC.PlannedConts[i].Age) {
                        nAmount = oCTC.PlannedConts[i].Amount;
                        if (oCTC.IACPlannedType === "A") {
                            nAdviserCharge = oCTC.IACPlannedAmount;
                        } else {
                            nAdviserCharge = nAmount * oCTC.IACPlannedAmount / 100.0;
                        }

                        this.results.Contributions[nCurrentYear] += nAmount;
                        nAmount -= nAdviserCharge;
                        this.results.AdviserIncome[nCurrentYear] += nAdviserCharge;
                        nFund += nAmount;
                    }
                }
            }

            // PCLS
            nPCLS = 0.0;
            if (oCTC.PCLSAge) {
                if (this.formatDPS(nAge, 2) == oCTC.PCLSAge) {
                    nPCLS += (nFund * (oCTC.PCLSPercentage / 100.0));
                    nFund = nFund * (1.0 - oCTC.PCLSPercentage / 100.0);
                    if (oCTC.CapitalGtees) {
                        for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                            if (oCTC.CapitalGtees[i].FundValue !== 0.0) {
                                nAmount = oCTC.CapitalGtees[i].FundValue;
                                nPCLS += (nAmount * (oCTC.PCLSPercentage / 100.0));
                                oCTC.CapitalGtees[i].FundValue = oCTC.CapitalGtees[i].FundValue * (1.0 - oCTC.PCLSPercentage / 100.0);
                                if (nAmount !== 0.0) {
                                    oCTC.CapitalGtees[i].GMF = oCTC.CapitalGtees[i].GMF * oCTC.CapitalGtees[i].FundValue / nAmount;
                                } else {
                                    oCTC.CapitalGtees[i].GMF = 0.0;
                                }
                            }
                        }
                    }
                    if (oCTC.IncomeGtees) {
                        for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                            if (oCTC.IncomeGtees[i].FundValue !== 0.0) {
                                nAmount = oCTC.IncomeGtees[i].FundValue;
                                nPCLS += (nAmount * (oCTC.PCLSPercentage / 100.0));
                                oCTC.IncomeGtees[i].FundValue = oCTC.IncomeGtees[i].FundValue * (1.0 - oCTC.PCLSPercentage / 100.0);
                                if (nAmount !== 0.0) {
                                    oCTC.IncomeGtees[i].SIB = oCTC.IncomeGtees[i].SIB * oCTC.IncomeGtees[i].FundValue / nAmount;
                                } else {
                                    oCTC.IncomeGtees[i].SIB = 0.0;
                                }
                            }
                        }
                    }
                }
            }
            nIncomeAmount = 0.0;

            if (this.formatDPS(nAge, 4) < oCTC.PRA) {
                // accumulation phase

                if (this.formatDPS(nAge, 4) <= 75.0) {
                    for (i = 0; i < oCTC.RegularConts.length; i++) {
                        if (oCTC.RegularConts[i].Frequency === "A") {
                            nFreq = 1;
                        } else {
                            nFreq = 12;
                        }
                        if ((this.formatDPS(nAge, 2) >= oCTC.RegularConts[i].Age) && (this.formatDPS(nAge, 2) < oCTC.RegularConts[i].StopAge) && (((nCurrentMonth - 1) % (12 / nFreq)) === 0)) {
                            nAmount = oCTC.RegularConts[i].Amount;
                            if ((nAdditionalContribution > 0.0) && (i == 0) && (oCTC.ProjectionMethod != 6)) {
                                nAmount += nAdditionalContribution;
                            }

                            nAmount = nAmount * Math.pow(1.0 + oCTC.RegularConts[i].Escalation / 100, Math.floor(this.formatDPS(nAge, 2) - oCTC.RegularConts[i].Age));
                            // (this.formatDPS(nAge + 1 / 12, 4) == oCTC.PRA)
                            //if (growthResults && oCTC.RegularConts[i].SourceType) {
                            //    switch (oCTC.RegularConts[i].SourceType) {
                            //        case 'Employee':
                            //            growthResults.TotalEmployeeContributions += nAmount;
                            //            break;
                            //        default:
                            //            growthResults.TotalEmployerContributions += nAmount;
                            //            break;
                            //    }
                            //}

                            if (nAmount >= 0.0) {
                                if (oCTC.RegularContsVariance) {
                                    for (j = 0; j < oCTC.RegularContsVariance.length; j++) {
                                        if (this.formatDPS(nAge, 2) >= oCTC.RegularContsVariance[j].Age) {
                                            if (oCTC.RegularContsVariance[j].VarianceType === "A") {
                                                nAmount += oCTC.RegularContsVariance[j].Amount;
                                            } else {
                                                nAmount = nAmount * (1.0 + oCTC.RegularContsVariance[j].Amount / 100.0);
                                            }
                                        }
                                    }
                                }

                                this.results.Contributions[nCurrentYear] += nAmount;

                                nAdviserCharge = 0.0;
                                if (oCTC.IACRegsPeriod) {
                                    if (this.formatDPS(nAge, 2) < (oCTC.RegularConts[i].Age + oCTC.IACRegsPeriod / 12)) {
                                        if (oCTC.IACRegsType === "A") {
                                            nAdviserCharge = oCTC.IACRegsAmount;
                                        } else {
                                            nAdviserCharge = nAmount * oCTC.IACRegsAmount / 100.0;
                                        }
                                    }
                                }
                                nAmount -= nAdviserCharge;
                                this.results.AdviserIncome[nCurrentYear] += nAdviserCharge;

                                nFund += nAmount;
                            }
                        }
                    }
                }
            } else {
                // Regular Income

                if (bIncludeIncome) {
                    if (oCTC.Income) {
                        for (i = 0; i < oCTC.Income.length; i++) {
                            if (this.formatDPS(nAge, 2) >= oCTC.Income[i].IncomeStartAge) {
                                if (oCTC.Income[i].Frequency === "A") {
                                    nFreq = 1;
                                } else {
                                    nFreq = 12;
                                }
                                nPaymentMonth = this.roundToInteger((nAge - oCTC.Income[i].IncomeStartAge) * 12) + 1;
                                if ((((nPaymentMonth - 1) % (12 / nFreq)) === 0) && (nPaymentMonth <= (oCTC.Income[i].Term * 12))) {
                                    nAmount = oCTC.Income[i].Amount;
                                    if ((nAdditionalIncome > 0.0) && (i == 0)) {
                                        nAmount += nAdditionalIncome;
                                    }
                                    nIncomeAmount += nAmount * Math.pow(1.0 + oCTC.Income[i].Escalation / 100, Math.floor((nPaymentMonth - 1) / 12));
                                }
                            }
                        }
                    }

                    if (nIncomeAmount > 0.0) {
                        if (oCTC.IncomeVariance) {
                            for (j = 0; j < oCTC.IncomeVariance.length; j++) {
                                if (this.formatDPS(nAge, 2) >= oCTC.IncomeVariance[j].Age) {
                                    if (oCTC.IncomeVariance[j].VarianceType === "A") {
                                        nIncomeVarianceAmount = oCTC.IncomeVariance[j].Amount;
                                        if (oCTC.Income.length > 0) {
                                            // Use the escalation on the first income choice
                                            nIncomeVarianceEscalation = Math.pow(1.0 + oCTC.Income[0].Escalation / 100, Math.floor(this.formatDPS(nAge, 2) - oCTC.IncomeVariance[j].Age));
                                        } else {
                                            nIncomeVarianceEscalation = 1.0;
                                        }
                                        nIncomeAmount += nIncomeVarianceAmount * nIncomeVarianceEscalation;
                                    } else {
                                        nIncomeAmount = nIncomeAmount * (1.0 + oCTC.IncomeVariance[j].Amount / 100.0);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if ((bIncludeIncome) && (this.formatDPS(nAge, 2) >= 55)) {
                if (oCTC.PlannedIncome) {
                    for (i = 0; i < oCTC.PlannedIncome.length; i++) {
                        if (this.formatDPS(nAge, 2) == oCTC.PlannedIncome[i].Age) {
                            nIncomeAmount += oCTC.PlannedIncome[i].Amount;
                        }
                    }
                }
            }

            if (nIncomeAmount > 0.0) {
                if (!bIncomeStarted) { bTestFundState = true; }
                bIncomeStarted = true;
                nTotalGteeFund = 0.0;
                if (oCTC.CapitalGtees) {
                    for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                        nTotalGteeFund += oCTC.CapitalGtees[i].FundValue;
                    }
                }
                if (oCTC.IncomeGtees) {
                    for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                        nTotalGteeFund += oCTC.IncomeGtees[i].FundValue;
                    }
                }

                if ((nFund > nIncomeAmount) || (bIsTargetting && (nTotalGteeFund === 0.0))) {
                    nFund -= nIncomeAmount;
                    this.results.Income[nCurrentYear] += nIncomeAmount;
                } else {
                    // take what is remaining from non-guaranteed fund
                    this.results.Income[nCurrentYear] += nFund;

                    if (((((nFund + nTotalGteeFund) < nIncomeAmount) && (bIsTargetting)) || (((nFund + nTotalGteeFund) <= oCTC.TargetFund) && (!bIsTargetting))) && (this.results.FundRanOutAge === -1)) {
                        this.results.FundRanOutAge = nAge;
                    }

                    if (nFund > 0.0) {
                        nIncomeAmount -= nFund;
                    }
                    nFund = 0.0;
                    nIncomeTakenFromGteed = Math.min(nIncomeAmount, nTotalGteeFund);
                    if (nTotalGteeFund > 0.0) {
                        // now take remaining income proportionally from guaranteed funds if any
                        nIncomeAmount -= nIncomeTakenFromGteed;
                        this.results.Income[nCurrentYear] += nIncomeTakenFromGteed;
                        if (oCTC.CapitalGtees) {
                            for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                                if (oCTC.CapitalGtees[i].FundValue !== 0.0) {
                                    nAmount = oCTC.CapitalGtees[i].FundValue;
                                    oCTC.CapitalGtees[i].FundValue -= (nIncomeTakenFromGteed * oCTC.CapitalGtees[i].FundValue / nTotalGteeFund);
                                    oCTC.CapitalGtees[i].GMF = oCTC.CapitalGtees[i].GMF * oCTC.CapitalGtees[i].FundValue / nAmount;
                                }
                            }
                        }
                        if (oCTC.IncomeGtees) {
                            for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                                if (oCTC.IncomeGtees[i].FundValue !== 0.0) {
                                    nAmount = oCTC.IncomeGtees[i].FundValue;
                                    oCTC.IncomeGtees[i].FundValue -= (nIncomeTakenFromGteed * oCTC.IncomeGtees[i].FundValue / nTotalGteeFund);
                                    oCTC.IncomeGtees[i].SIB = oCTC.IncomeGtees[i].SIB * oCTC.IncomeGtees[i].FundValue / nAmount;
                                }
                            }
                        }
                    }
                    if ((bIsTargetting) && (nIncomeAmount > 0)) {
                        nFund -= nIncomeAmount;
                    }
                }
            }
            this.results.Income[nCurrentYear] += nPCLS;

            // deal with other income sources
            if (oCTC.OtherIncomeInput) {
                for (i = 0; i < oCTC.OtherIncomeInput.length; i++) {
                    if ((this.formatDPS(nAge, 2) >= oCTC.OtherIncomeInput[i].StartAge) && (this.formatDPS(nAge, 2) <= oCTC.OtherIncomeInput[i].EndAge)) {
                        nPaymentMonth = this.roundToInteger((nAge - oCTC.OtherIncomeInput[i].StartAge) * 12) + 1;
                        if (((nPaymentMonth - 1) % 12) === 0) {
                            nAmount = oCTC.OtherIncomeInput[i].AnnualIncome * Math.pow(1.0 + oCTC.OtherIncomeInput[i].Escalation / 100, Math.floor((nPaymentMonth - 1) / 12));
                            this.results.OtherIncome[nCurrentYear] += nAmount;
                        }
                    }
                }
            }

            nTotalGteeFund = 0.0;
            if (oCTC.CapitalGtees) {
                for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                    if (oCTC.CapitalGtees[i].FundValue !== 0.0) {
                        nMonthlyGrowth = Math.pow(Math.pow(Math.pow(1 + nGrowth / 100, 1 / 12) * (1 - (oCTC.FMC + oCTC.CapitalGtees[i].GteeCharge) / 1200), 12), 1 / 12);
                        oCTC.CapitalGtees[i].FundValue = oCTC.CapitalGtees[i].FundValue * nMonthlyGrowth;
                        nTotalGteeFund += oCTC.CapitalGtees[i].FundValue;
                    }
                }
            }
            if (oCTC.IncomeGtees) {
                for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                    if (oCTC.IncomeGtees[i].FundValue !== 0.0) {
                        nMonthlyGrowth = Math.pow(Math.pow(Math.pow(1 + nGrowth / 100, 1 / 12) * (1 - (oCTC.FMC + oCTC.IncomeGtees[i].GteeCharge) / 1200), 12), 1 / 12);
                        oCTC.IncomeGtees[i].FundValue = oCTC.IncomeGtees[i].FundValue * nMonthlyGrowth;
                        nTotalGteeFund += oCTC.IncomeGtees[i].FundValue;
                    }
                }
            }

            nMonthlyGrowth = Math.pow(Math.pow(Math.pow(1 + nGrowth / 100, 1 / 12) * (1 - oCTC.FMC / 1200), 12), 1 / 12);
            nFund = nFund * nMonthlyGrowth;

            nAdviserCharge = 0.0;
            if (oCTC.AdhocCharges) {
                for (i = 0; i < oCTC.AdhocCharges.length; i++) {
                    if (this.formatDPS(nAge, 2) == oCTC.AdhocCharges[i].Age) {
                        nAmount = oCTC.AdhocCharges[i].Amount;
                        if (oCTC.AdhocCharges[i].Type === "A") {
                            nAdviserCharge += oCTC.AdhocCharges[i].Amount;
                        } else {
                            nAdviserCharge += (nFund + nTotalGteeFund) * oCTC.AdhocCharges[i].Amount / 100.0;
                        }
                    }
                }
            }

            if (oCTC.OACAmount) {
                if (oCTC.OACType === "A") {
                    nAdviserCharge += oCTC.OACAmount;
                } else {
                    nAdviserCharge += (nFund + nTotalGteeFund) * oCTC.OACAmount / 1200.0;
                }
            }

            if (bApplyDefaultProductCharge) {
                nProductChargeRate = this.getProductChargeRate(nFund + nTotalGteeFund) / 1200;
                nProductCharge = nFund * nProductChargeRate;
            } else {
                nProductCharge = 0;
            }
            if (nAdviserCharge > 0.0) {
                nTotalGteeFund = 0.0;
                if (oCTC.CapitalGtees) {
                    for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                        nTotalGteeFund += oCTC.CapitalGtees[i].FundValue;
                    }
                }
                if (oCTC.IncomeGtees) {
                    for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                        nTotalGteeFund += oCTC.IncomeGtees[i].FundValue;
                    }
                }

                if ((nFund > nAdviserCharge) || (bIsTargetting && (nTotalGteeFund === 0.0))) {
                    nFund -= nAdviserCharge;
                    this.results.AdviserIncome[nCurrentYear] += nAdviserCharge;
                } else {
                    // take what is remaining from non-guaranteed fund
                    this.results.AdviserIncome[nCurrentYear] += nFund;

                    if (nFund > 0.0) {
                        nAdviserCharge -= nFund;
                    }
                    nFund = 0.0;
                    nOACTakenFromGteed = Math.min(nAdviserCharge, nTotalGteeFund);
                    if (nTotalGteeFund > 0.0) {
                        // now take remaining income proportionally from guaranteed funds if any
                        this.results.AdviserIncome[nCurrentYear] += nOACTakenFromGteed;
                        nAdviserCharge = 0;
                        if (oCTC.CapitalGtees) {
                            for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                                if (oCTC.CapitalGtees[i].FundValue !== 0.0) {
                                    nAmount = oCTC.CapitalGtees[i].FundValue;
                                    oCTC.CapitalGtees[i].FundValue -= (nOACTakenFromGteed * oCTC.CapitalGtees[i].FundValue / nTotalGteeFund);
                                    oCTC.CapitalGtees[i].GMF = oCTC.CapitalGtees[i].GMF * oCTC.CapitalGtees[i].FundValue / nAmount;
                                }
                            }
                        }
                        if (oCTC.IncomeGtees) {
                            for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                                if (oCTC.IncomeGtees[i].FundValue !== 0.0) {
                                    nAmount = oCTC.IncomeGtees[i].FundValue;
                                    oCTC.IncomeGtees[i].FundValue -= (nOACTakenFromGteed * oCTC.IncomeGtees[i].FundValue / nTotalGteeFund);
                                    oCTC.IncomeGtees[i].SIB = oCTC.IncomeGtees[i].SIB * oCTC.IncomeGtees[i].FundValue / nAmount;
                                }
                            }
                        }
                    }
                    if ((bIsTargetting) && (nAdviserCharge > 0)) {
                        nFund -= nAdviserCharge;
                    }
                }
            }

            nFund -= nProductCharge;
            nTotalGteeFund = 0.0;
            //Deal with end of Gtee periods
            if (oCTC.CapitalGtees) {
                for (i = 0; i < oCTC.CapitalGtees.length; i++) {
                    oCTC.CapitalGtees[i].FundValue = oCTC.CapitalGtees[i].FundValue * (1.0 - nProductChargeRate);
                    if (nCurrentMonth === (oCTC.CapitalGtees[i].Term * 12)) {
                        nFund = nFund + Math.max(oCTC.CapitalGtees[i].FundValue, oCTC.CapitalGtees[i].GMF);
                        oCTC.CapitalGtees[i].FundValue = 0.0;
                    }
                    nTotalGteeFund += oCTC.CapitalGtees[i].FundValue;
                }
            }

            if (oCTC.IncomeGtees) {
                for (i = 0; i < oCTC.IncomeGtees.length; i++) {
                    if (nCurrentMonth <= (oCTC.IncomeGtees[i].Term * 12)) {
                        oCTC.IncomeGtees[i].FundValue = oCTC.IncomeGtees[i].FundValue * (1.0 - nProductChargeRate);
                        if (nCurrentMonth === (oCTC.IncomeGtees[i].Term * 12)) {
                            nFund += oCTC.IncomeGtees[i].FundValue;
                            oCTC.IncomeGtees[i].FundValue = 0.0;
                        } else {
                            nAmount = oCTC.IncomeGtees[i].SIB * oCTC.IncomeGtees[i].GIRs / 1200.0;
                            nFund += nAmount;
                            oCTC.IncomeGtees[i].FundValue = Math.max(oCTC.IncomeGtees[i].FundValue - nAmount, 0.0);
                            if (nCurrentMonth <= 12) {
                                this.results.GuaranteedIncome += nAmount;
                            }
                        }
                    }
                    nTotalGteeFund += oCTC.IncomeGtees[i].FundValue;
                }
            }
            this.results.Fund[nCurrentYear] = nFund + nTotalGteeFund;

            if (this.formatDPS(nAge + 1 / 12, 4) == oCTC.PRA) {
                this.results.FundAtPRA = this.results.Fund[nCurrentYear];
            }

            if (bTestFundState) {
                bFundGreaterThanTargetAtIncomeStart = (this.results.Fund[nCurrentYear] >= oCTC.TargetFund);
                bTestFundState = false;
            }

            if ((((this.results.Fund[nCurrentYear] <= oCTC.TargetFund) && bFundGreaterThanTargetAtIncomeStart) || ((this.results.Fund[nCurrentYear] >= oCTC.TargetFund) && !bFundGreaterThanTargetAtIncomeStart)) && (oCTC.ProjectionMethod == 3) && (bIncomeStarted)) {
                if (this.results.FundRanOutAge === -1) {
                    this.results.FundRanOutAge = nAge;
                }
                break;
            }

            nAge = nAge + parseFloat(1.0 / 12.0);
        }

        //if (growthResults) {
        //    growthResults.ProjectedFund = nFund + nTotalGteeFund;
        //}
        return (nFund + nTotalGteeFund);
    };

    this.Sn = function (i, AMC, Esc, Term, m) {
        var t1 = 0;
        var t2 = 0;
        var t3 = 0;
        var G = 0.0;
        var g1 = 0.0;
        var Whole = 0.0;
        var Part = 0.0;

        i = Math.pow(Math.pow(1 + i, 1 / 12) * (1 - AMC / 12), 12) - 1;

        t1 = Math.floor(Term + 0.0000001);
        t2 = (Term - t1) * m;

        if (((Term - t1) > 0) && (m !== 12)) {
            t2 = Math.floor(t2 + 1.0000001) / m;
        } else {
            t2 = Math.floor(t2 + 0.0000001) / m;
        }

        t3 = Math.floor((Term - t1) * 12 + 0.0000001) / 12;
        g1 = (1 + i) / (1 + Esc);
        if (i == Esc) {
            G = t1;
        } else {
            G = (Math.pow(g1, t1) - 1) / (1 - 1 / g1);
        }

        if (i !== 0) {
            Whole = (i / (1 + i)) / (1 - 1 / Math.pow(1 + i, 1 / m));
            Part = (1 - 1 / Math.pow(1 + i, t2)) / (1 - 1 / Math.pow(1 + i, 1 / m));
        } else {
            Whole = m;
            Part = m * t2;
        }
        return (Whole * G + Part) * Math.pow(1 + i, t3) * Math.pow(1 + Esc, t1);
    };

    this.populateSurvival = function (DOBYear, nAgeAtStart, nTotalYears) {
        var i;

        for (i = 0; i < nTotalYears; i++) {
            this.results.ProbabilityOfSurvival[i] = this.getMortalityRate(DOBYear, parseInt(nAgeAtStart + i, 10)) * 100.0;
        }
    };

    this.roundResultsAndAdjustForInflation = function (oCTC, nAccumulationMonths, realBoolean) {
        var nTotalYears = 0;
        var nAccumulationTermYears = 0;
        var nInflation = this.inflationPcnt;
        var nDiscount = 1.0;
        var i = 0;

        if (realBoolean) {
            nDiscount = 1.0 + nInflation / 100.0;
        } else {
            nDiscount = 1.0;
        }

        nAccumulationTermYears = Math.floor(nAccumulationMonths / 12.0);
        this.results.FundAtPRA = Math.max(this.formatDPS(this.results.FundAtPRA / Math.pow(nDiscount, nAccumulationTermYears), 2), 0.0);
        this.results.GuaranteedIncome = this.formatDPS(this.results.GuaranteedIncome, 2);
        if ((oCTC.ProjectionMethod == 2) || (oCTC.ProjectionMethod == 7)) {
            this.results.GrossTargetAmount = this.results.GrossTargetAmount * (1.0 - oCTC.TaxRate / 100.0);
        }
        this.results.GrossTargetAmount = this.formatDPS(this.results.GrossTargetAmount, 2);
        if (this.results.FundRanOutAge == -1) {
            this.results.FundRanOutAge = 120;
        } else {
            this.results.FundRanOutAge = Math.round(this.results.FundRanOutAge, 4);
        }

        nTotalYears = this.results.Fund.length;
        for (i = 0; i < nTotalYears; i++) {
            this.results.Contributions[i] = this.results.Contributions[i] * (1.0 - oCTC.TaxRate / 100.0);
            if (((oCTC.ProjectionMethod == 1) || (oCTC.ProjectionMethod == 2)) && (i == (nAccumulationTermYears + 1))) {
                this.results.Fund[i] = this.formatDPS(Math.max(this.results.Fund[i] / Math.pow(nDiscount, nAccumulationTermYears), 0.0), 2);
                this.results.Contributions[i] = this.formatDPS(Math.max(this.results.Contributions[i] / Math.pow(nDiscount, nAccumulationTermYears), 0.0), 2);
                this.results.AdviserIncome[i] = this.formatDPS(Math.max(this.results.AdviserIncome[i] / Math.pow(nDiscount, nAccumulationTermYears), 0.0), 2);
                this.results.OtherIncome[i] = this.formatDPS(Math.max(this.results.OtherIncome[i] / Math.pow(nDiscount, nAccumulationTermYears), 0.0), 2);
            } else {
                this.results.Fund[i] = this.formatDPS(Math.max(this.results.Fund[i] / Math.pow(nDiscount, i + 1), 0.0), 2);
                this.results.Income[i] = this.formatDPS(Math.max(this.results.Income[i] / Math.pow(nDiscount, i + 1), 0.0), 2);
                this.results.Contributions[i] = this.formatDPS(Math.max(this.results.Contributions[i] / Math.pow(nDiscount, i + 1), 0.0), 2);
                this.results.AdviserIncome[i] = this.formatDPS(Math.max(this.results.AdviserIncome[i] / Math.pow(nDiscount, i + 1), 0.0), 2);
                this.results.OtherIncome[i] = this.formatDPS(Math.max(this.results.OtherIncome[i] / Math.pow(nDiscount, i + 1), 0.0), 2);
            }
        }
    };

    this.calculateIncomeEndMonth = function (Incomes, nAgeAtStart) {
        var i = 0;
        var j = 0;
        var nIncomeEndMonth = 0;

        nIncomeEndMonth = 0;
        if (Incomes.length > 0) {
            for (i = 0; i < Incomes.length; i++) {
                j = Math.floor(((Math.min(Incomes[i].IncomeStartAge + Incomes[i].Term, 120)) - nAgeAtStart) * 12 + 0.00001);
                if (j > nIncomeEndMonth) {
                    nIncomeEndMonth = j;
                }
            }
        }

        return nIncomeEndMonth;
    };

    this.getAnnuityRate = function (nYearofBirth, AIP, nNra, nSpouse, sIncreaseType, nGuarantee) {
        var nAgeDiff = 0;
        var expenseLoading = 1.04;
        var Npx = 1.0;
        var Npy = 1.0;
        var Vn = 0.0;
        var nAnnIntRate = 0.0;
        var nIFrq = 0.0;
        var nResult = 0.0;
        var nCount = 0;
        var npaymentAdj = 0.0;
        var nMaxLoop = 0;

        if ((sIncreaseType == 'LPI') || (sIncreaseType == 'RPI')) {
            nAnnIntRate = AIP / 100;
        } else {
            nAnnIntRate = (1 + AIP / 100) / (1 + sIncreaseType / 100) - 1;
        }

        nIFrq = Math.pow(1 + nAnnIntRate, 1 / 12);
        npaymentAdj = 13 / 24;

        if (nIFrq != 1) {
            nIFrq = nAnnIntRate * nIFrq / 12 / (nIFrq - 1);
        } else {
            nIFrq = 1;
        }

        Npx = 1.0;
        Npy = 1.0;
        Vn = 1.0;

        if (nSpouse > 0) {
            nMaxLoop = Math.max(120, 120 + nAgeDiff);
        } else {
            nMaxLoop = 120;
        }

        for (nCount = nNra; nCount <= nMaxLoop; nCount++) {
            Npx = (1 - this.getUnisexRate(nYearofBirth, nCount)) * Npx;
            Vn = Vn * 1 / (1 + nAnnIntRate);
            if ((nCount >= nNra) && (nCount <= (nNra + nGuarantee - 1))) {
                nResult = nResult + Vn * nIFrq
                if (nCount == (nNra + nGuarantee - 1)) {
                    nResult = nResult + Vn * Npx * npaymentAdj;
                }
            } else {
                nResult = nResult + Vn * Npx;
            }

            if (nSpouse > 0) {
                Npy = Npy * (1 - this.getUnisexRate(nYearofBirth + nAgeDiff, nCount - nAgeDiff));
                nResult = nResult + Vn * Npy * (1 - Npx) * nSpouse / 100;
            }
        }

        if (nGuarantee == 0) {
            nResult = nResult + npaymentAdj;
        }

        nResult = nResult * expenseLoading;

        return Math.floor(nResult * 1000 + 0.5) / 1000;
    }

    this.getAnnuity = function (nYearofBirth, nNra, nSpouse, sIncreaseType, nGuarantee, sBasis) {
        var iAIP = this.AIR;
        var iAnnRate = 0.0;

        if (sIncreaseType == 'RPI' || sIncreaseType == 'LPI' || sIncreaseType == 'CPI') {
            if (sBasis == 'low') {
                iAIP -= 1;
            } else if (sBasis == 'high') {
                iAIP += 1;
            }
        } else {
            if (sBasis == 'low') {
                iAIP += 1.5;
            } else if (sBasis == 'high') {
                iAIP += 5.5;
            } else {
                iAIP += 3.5;
            }
        }
        iAnnRate = this.getAnnuityRate(nYearofBirth, iAIP, nNra, nSpouse, sIncreaseType, nGuarantee);
        return iAnnRate;
    }
}

module.exports = function RunPAT(oCTC, realBoolean) {
    var oProjection;
    var arrResults = [];
    var sRegion;
    var sBasis;
    var nGrowthModifier = 0.0;
    var nAnnRate = 0.0;
    var salInc = 0.0;
    var discountRate = 0.0;
    var nTerm = 0;
    var employerCont = 0.0;
    var employeeCont = 0.0;
    var salSacIndicator = false;
    var grossSalary = 0.0;
    var nFV = 0.0;
    var newIndex = 0;

    switch (oCTC.Location) {
        case 'Scotland':
        case 'scotland':
            sRegion = 'Scotland';
            break;
        default:
            sRegion = 'England';
            break;
    }

    oProjection = new CTCModellerProjection();
    // oProjection.formateValueInputs(oCTC);
    if (oCTC.AnnualIncomeRequired) {
        oCTC.Income = [];
        newIndex = oCTC.Income.length;
        oCTC.Income[newIndex] = new Object();
        oCTC.Income[newIndex].Frequency = "M";
        oCTC.Income[newIndex].IncomeStartAge = oCTC.PRA;
        oCTC.Income[newIndex].Term = 120 - oCTC.PRA;
        oCTC.Income[newIndex].Amount = oCTC.AnnualIncomeRequired / 12;
        oCTC.TargetFund = oCTC.Income[newIndex].Amount - 1.0;

        if (oCTC.AnnualIncomeReqIncrease) {
            oCTC.Income[newIndex].Escalation = parseFloat(oCTC.AnnualIncomeReqIncrease);
        } else {
            oCTC.Income[newIndex].Escalation = 0.0;
        }
    }
    oProjection.initialiseProjectionData(oCTC.PRA, sRegion, oCTC.Location, null, null, oCTC.Age, false, oCTC.Income);
    if (oCTC.AMC) {
        oCTC.FMC = oCTC.AMC;
    } else {
        oCTC.FMC = 0;
    }

    for (var i = 0; i <= 2; i++) {
        switch (i) {
            case 0:
                sBasis = 'low';
                nGrowthModifier = -3.0;
                break;
            case 1:
                sBasis = 'mid';
                nGrowthModifier = 0.0;
                break;
            case 2:
                sBasis = 'high';
                nGrowthModifier = 3.0;
                break;
        }
        arrResults[i] = new CTCModellerGrowthResults();
        arrResults[i].growthLevel = sBasis;

        if (oCTC.AnnualEarnings) {
            grossSalary = parseFloat(oCTC.AnnualEarnings);
            if (oCTC.AnnualEarningsIncrease && grossSalary > 0) {
                salInc = parseFloat(oCTC.AnnualEarningsIncrease);
            } else {
                salInc = 0.0;
            }
        }

        oCTC.RegularConts = [];
        if (oCTC.EmployeeCont) {
            newIndex = oCTC.RegularConts.length;
            oCTC.RegularConts[newIndex] = new Object();
            switch (oCTC.EmployeeContType) {
                case 'P':
                    if (oCTC.AnnualEarnings) {
                        employeeCont = grossSalary * parseFloat(oCTC.EmployeeCont) / 1200;
                        oCTC.RegularConts[newIndex].Amount = employeeCont;
                        oCTC.RegularConts[newIndex].Escalation = salInc;
                    }
                    break;
                default:
                    employeeCont = parseFloat(oCTC.EmployeeCont);
                    oCTC.RegularConts[newIndex].Amount = employeeCont;
                    oCTC.RegularConts[newIndex].Escalation = 0.0;
                    break;
            }
            oCTC.RegularConts[newIndex].SourceType = 'Employee';
            oCTC.RegularConts[newIndex].Frequency = 'M';
            oCTC.RegularConts[newIndex].Age = oCTC.Age;
            oCTC.RegularConts[newIndex].StopAge = 999;
        }

        if (oCTC.EmployerCont) {
            newIndex = oCTC.RegularConts.length;
            oCTC.RegularConts[newIndex] = new Object();
            switch (oCTC.EmployerContType) {
                case 'P':
                    if (oCTC.AnnualEarnings) {
                        employerCont = grossSalary * parseFloat(oCTC.EmployerCont) / 1200;
                        oCTC.RegularConts[newIndex].Amount = employerCont;
                        oCTC.RegularConts[newIndex].Escalation = salInc;
                    }
                    break;
                default:
                    employerCont = parseFloat(oCTC.EmployerCont);
                    oCTC.RegularConts[newIndex].Amount = employerCont;
                    oCTC.RegularConts[newIndex].Escalation = 0.0;
                    break;
            }
            oCTC.RegularConts[newIndex].SourceType = 'Employer';
            oCTC.RegularConts[newIndex].Frequency = 'M';
            oCTC.RegularConts[newIndex].Age = oCTC.Age;
            oCTC.RegularConts[newIndex].StopAge = 999;
        }
        if (realBoolean) {
            discountRate = oProjection.inflationPcnt / 100;
        } else {
            discountRate = 0.0;
        }
        nTerm = oCTC.PRA - oCTC.Age;
        oCTC.PCLSAge = oCTC.PRA;
        oCTC.PCLSPercentage = 25.0;
        oProjection.initialiseResults();
        oProjection.projectBenefitsForward(oCTC, oCTC.FundValue, oProjection.projectionData.TotalMonths, 0, 0, true, false, 0, false, nGrowthModifier, sBasis, arrResults[i]);
        nFV = oProjection.results.FundAtPRA;
        arrResults[i].ProjectedFund_Monetary = oProjection.formatDPS(nFV, 0);
        arrResults[i].ProjectedFund_Real = oProjection.formatDPS(nFV / Math.pow(1.0 + oProjection.inflationPcnt / 100, nTerm), 0);
        oProjection.results.FundAtPRA = oProjection.results.FundAtPRA / Math.pow(1.0 + discountRate, nTerm);
        //arrResults[i].ProjectedFund = oProjection.round3SigFig(oProjection.results.FundAtPRA);
        arrResults[i].TFC = oProjection.formatDPS(oProjection.results.FundAtPRA * 0.25, 0);
        nAnnRate = oProjection.getAnnuity(oProjection.projectionData.DOB.getFullYear(), oCTC.PRA, parseFloat(oCTC.SpousePercentage), oCTC.AnnuityEscalation, parseInt(oCTC.AnnuityGteeYears, 10), sBasis);
        arrResults[i].Annuity = oProjection.formatDPS((oProjection.results.FundAtPRA * 0.75) / nAnnRate, 0);
        arrResults[i].TaxDue = oProjection.formatDPS(oProjection.calculateTaxOnExcessTFC(100, oProjection.results.FundAtPRA), 0);
        arrResults[i].FundExhausionAge = Math.floor(oProjection.results.FundRanOutAge + 0.00001);
        arrResults[i].TotalEmployerContributions = oProjection.formatDPS(employerCont * 12 * nTerm, 0);
        arrResults[i].TotalEmployeeContributions = oProjection.formatDPS(employeeCont * 12 * nTerm, 0);
        if (oCTC.SalarySacrificeInd && grossSalary > 0.0) {
            salSacIndicator = oCTC.SalarySacrificeInd == "Yes";
        }
        arrResults[i].TotalNetContributions = oProjection.formatDPS(oProjection.calculateNetCost(salSacIndicator, employeeCont * 12, grossSalary) * nTerm, 0);
        arrResults[i].TotalTaxRelief = oProjection.formatDPS(arrResults[i].TotalEmployeeContributions - arrResults[i].TotalNetContributions, 0);
        arrResults[i].TotalPotentialGrowth = oProjection.formatDPS((oProjection.results.FundAtPRA - (oCTC.FundValue + arrResults[i].TotalEmployeeContributions + arrResults[i].TotalEmployerContributions)), 0 );
        arrResults[i].ResidualFundBeforeTax = oProjection.formatDPS(0.75 * oProjection.results.FundAtPRA, 0);
        arrResults[i].ResidualFundAfterTax = oProjection.formatDPS(0.75 * oProjection.results.FundAtPRA - arrResults[i].TaxDue, 0);
        arrResults[i].TotalContribution = oProjection.formatDPS(employeeCont, 0);
        arrResults[i].ActualCostToYou = oProjection.formatDPS(oProjection.calculateNetCost(salSacIndicator, employeeCont * 12, grossSalary)/12.0, 0);
    }

    return arrResults;
}

function RunProjection(oCTC, realBoolean, partBoolean) {
    var oProjection;
    var nOffset = 0;
    var nAgeAtStart = 0.0;
    var nAgeAtEnd = 0.0;

    oProjection = new CTCModellerProjection();
    oProjection.initialiseProjectionData(oCTC.PRA, oCTC.Location, null, oCTC.Gender, oCTC.DateOfBirth, null, ((oCTC.ProjectionMethod === 3) || (oCTC.ProjectionMethod === 4)), oCTC.Income);
    nAgeAtStart = oProjection.projectionData.AgeAtStart;
    nAgeAtEnd = oProjection.projectionData.AgeAtEnd;

    if (partBoolean) {
        nOffset = Math.floor(((nAgeAtStart - parseInt(nAgeAtStart, 10)) * 12) + 0.00001);
        nOffset = parseInt(nOffset, 10);
    }

    oProjection.initialiseResults();
    oProjection.initialiseInputObjects(oCTC, nAgeAtStart, nAgeAtEnd);

    switch (oCTC.ProjectionMethod) {
        case 1:
            oProjection.projectBenefitsForward(oCTC, oCTC.FundValue, oProjection.projectionData.AccumulationMonths, 0, 0, true, false, nOffset, true);
            break;
        case 2:
            oProjection.results.GrossTargetAmount = oProjection.getTargetContributionOrGrowth(oCTC, oProjection.projectionData.AccumulationMonths, realBoolean, nOffset, true);
            break;
        case 3:
            oProjection.projectBenefitsForward(oCTC, oCTC.FundValue, oProjection.projectionData.TotalMonths, 0, 0, true, false, nOffset, true);
            break;
        case 4:
            oProjection.results.GrossTargetAmount = oProjection.getMaximumIncome(oCTC, oProjection.projectionData.TotalMonths, nOffset);
            break;
        case 5:
            oProjection.results.GrossTargetAmount = oProjection.getTargetContributionOrGrowth(oCTC, -1, realBoolean, nOffset);
            break;
        case 6:
            oProjection.results.GrossTargetAmount = oProjection.getTargetContributionOrGrowth(oCTC, -1, realBoolean, nOffset);
            break;
        case 7:
            oProjection.results.GrossTargetAmount = oProjection.getTargetContributionOrGrowth(oCTC, -1, realBoolean, nOffset);
            break;
        default:
            break;
    }

    oProjection.populateSurvival(oProjection.formatDateObject(oCTC.DateOfBirth).getFullYear(), nAgeAtStart, oProjection.results.Fund.length);
    oProjection.roundResultsAndAdjustForInflation(oCTC, oProjection.projectionData.AccumulationMonths, realBoolean);
    return oProjection.results;
}



// WEBPACK FOOTER //
// ./src/calculator/ctcModeller.js